import { getUrlForCommit, linkifyText } from '../state/github';
import { CommitProps } from '../state/types';
import { Cell } from './Cell';
import './components.css';

export type Props = CommitProps;

export function CommitCell(props: Props) {
  const message = props.message || "Check for presence of __l (#495) asdjio dsajifodsa fdjsaio";
  return <Cell rowspan={props.rowspan}>
    <div class="hash">
      <a target="_blank" href={getUrlForCommit(props)}>{props.hash}</a>
    </div>
    <div class="message"
      data-tooltip-id="commit-tooltip"
      data-tooltip-html={linkifyText(message)}
    >{message}</div>
  </Cell>;
}
